import LocalizedMessage from '../common/LocalizedMessage';
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, useLocation, useParams } from "react-router-dom";
import ClientService from "../../services/ClientService";
import StudentService from "../../services/StudentService";
import { buildManageRouteWithSchoolYear, getNormalizedSchoolYearStartYearFromSearch } from "./manageSchoolYearRouting";
import { useTranslation } from 'react-i18next';

export default function TeacherPeopleProfile({ kind }) {
  const { t: tr } = useTranslation();
  const { id } = useParams();
  const location = useLocation();
  const [result, setResult] = useState({});
  const isStudent = kind === "student";
  const year = getNormalizedSchoolYearStartYearFromSearch(location.search);
  const route = path => buildManageRouteWithSchoolYear(path, "", year);

  useEffect(() => {
    let active = true;
    setResult({});
    const request = isStudent ? StudentService.getStudent(id) : ClientService.getClient(id);
    request.then(profile => {
      if (active) setResult({ profile });
    }).catch(() => {
      if (active) setResult({ error: tr("manage:integratedText69") });
    });
    return () => { active = false; };
  }, [id, isStudent]);

  const { profile, error } = result;
  return (
    <div className="mb-5">
      <h2 className="manage-title">{isStudent ? tr("manage:student_14") : tr("manage:client_108")}</h2>
      {error && <div role="alert" className="alert alert-danger"><LocalizedMessage isError value={error} /></div>}
      {!profile && !error && <p role="status">{tr("manage:integratedText70")}</p>}
      {profile && (
        <dl className="row manage-text">
          <dt className="col-sm-3">{tr("manage:integratedText71")}</dt>
          <dd className="col-sm-9">{profile.firstName} {profile.lastName}</dd>
          {isStudent ? (
            <>
              <dt className="col-sm-3">{tr("manage:client_108")}</dt>
              <dd className="col-sm-9">
                {profile.clientId ? (
                  <Link to={route(`/manage/client/${profile.clientId}`)}>{profile.clientDisplayName || tr("manage:integratedText72")}</Link>
                ) : tr("manage:integratedText73")}
              </dd>
              <dt className="col-sm-3">{tr("manage:additionalInformation_353")}</dt>
              <dd className="col-sm-9">{profile.additionalInfo || "—"}</dd>
            </>
          ) : (
            <>
              <dt className="col-sm-3">{tr("manage:integratedText74")}</dt>
              <dd className="col-sm-9">{profile.email || "—"}</dd>
              <dt className="col-sm-3">{tr("common:phone")}</dt>
              <dd className="col-sm-9">{profile.mobile || "—"}</dd>
            </>
          )}
        </dl>
      )}
      <Link className="btn manage-button manage-teal-button" to={route(isStudent ? "/manage/students" : "/manage/clients")}>{tr("common:back")}</Link>
    </div>
  );
}

TeacherPeopleProfile.propTypes = {
  kind: PropTypes.oneOf(["student", "client"]).isRequired,
};
